var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lightboxImage !== null)?_c('div',{staticClass:"image-lightbox",on:{"click":function($event){return _vm.$store.commit('chat/setLightboxImage', null)}}},[_c('img',{attrs:{"src":_vm.lightboxImage}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }